<div class="package-select" [formGroup]="packageForm">
  <p class="billing-note">All packages are billed monthly. Cancel anytime. Each active member above your included allotment is $1/month, billed monthly.</p>

  <mat-radio-group formControlName="platformPackage" class="package-list" aria-label="Choose a MemberTrace package">
    <button
      type="button"
      class="package-card"
      *ngFor="let pkg of packages"
      [class.selected]="isSelected(pkg.id)"
      [class.recommended]="pkg.recommended"
      (click)="selectPackage(pkg.id)">
      <div class="package-card-top">
        <mat-radio-button
          [value]="pkg.id"
          (click)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()">
          {{ pkg.name }}
        </mat-radio-button>
        <span class="recommended-tag" *ngIf="pkg.recommended">Most Popular</span>
      </div>
      <div class="package-price">{{ pkg.price }}</div>
      <div class="package-included">{{ pkg.included }}</div>
      <p class="package-description">{{ pkg.description }}</p>
    </button>
  </mat-radio-group>
</div>
